export const css = {
	root: '_37OE5eiK',
	' _key': 'dashboard/dashbutton'
};

export default css;
